// extracted by mini-css-extract-plugin
export default {"box":"MUISelect_box__hUXsu","label":"MUISelect_label__j7Y+9","progress":"MUISelect_progress__Sry6O","placeholder":"MUISelect_placeholder__88oKP"};